import classnames from 'classnames';
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styles from './style.scss?__local';
import useFooter from 'useFooter';
import Err from 'ui-error';

function NotFound() {
  useFooter()

  return (
    <Err err='404 NotFound' />
  )
}

export default NotFound